import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ResumeQuoteEffects } from 'stores/resume-quote/resume-quote.effects';
import * as fromResumeQuote from './resume-quote.reducer';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(fromResumeQuote.resumeQuoteFeatureKey, fromResumeQuote.reducers, {
            metaReducers: fromResumeQuote.metaReducers,
        }),
        EffectsModule.forFeature([ResumeQuoteEffects]),
    ],
})
export class ResumeQuoteModule {}
